var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { attrs: { id: "modal-template" } },
    [
      _c("modal", [
        _c("div", { attrs: { slot: "header" }, slot: "header" }, [
          _c("h2", [_vm._v(_vm._s(_vm.question.title))]),
          _vm._v(" "),
          _c("h3", [_vm._v(_vm._s(_vm.question.subTitle))]),
        ]),
        _vm._v(" "),
        _c("div", { attrs: { slot: "body" }, slot: "body" }, [
          _c("div", {
            staticClass: "content_asset",
            domProps: { innerHTML: _vm._s(_vm.contentAsset) },
          }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "answersItemsWrapper" },
            _vm._l(this.answers, function (answer) {
              return _c(
                "div",
                {
                  key: answer.id,
                  staticClass: "answerItem",
                  attrs: { title: answer.text },
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      _vm.selectAnswer(answer.id)
                      _vm.submitQuestion()
                    },
                  },
                },
                [
                  _vm._v(
                    "\n                    " +
                      _vm._s(answer.title) +
                      "\n                "
                  ),
                ]
              )
            }),
            0
          ),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }